import { put, call } from "redux-saga/effects";
import { exceptionHandler } from "../pages/common/functions";
import { ratingConstants } from "../actions/constants/ratingConstant";
import RatingService from "../services/api/ratingService";

function* ratingGetSetting(request: any) {
	try {
		const result = yield call(
			RatingService.ratingGetSetting,
			request.input
		);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: ratingConstants.RatingSettingGetSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: ratingConstants.RatingSettingGetFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: ratingConstants.RatingSettingGetFailure,
			payload: error,
		});
	}
}

function* ratingUpdateSetting(request: any) {
	try {
		const result = yield call(
			RatingService.ratingUpdateSetting,
			request.input
		);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: ratingConstants.RatingSettingUpdateSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: ratingConstants.RatingSettingUpdateFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: ratingConstants.RatingSettingUpdateFailure,
			payload: error,
		});
	}
}

function* ratingGetDashboard(request: any) {
	try {
		const result = yield call(
			RatingService.ratingGetDashboard,
			request.input
		);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: ratingConstants.RatingDashboardSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: ratingConstants.RatingDashboardFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: ratingConstants.RatingDashboardFailure,
			payload: error,
		});
	}
}

function* ratingGetAppVersions(request: any) {
	try {
		const result = yield call(
			RatingService.ratingGetAppVersions,
			request.input
		);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: ratingConstants.RatingAppVersionsSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: ratingConstants.RatingAppVersionsFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: ratingConstants.RatingAppVersionsFailure,
			payload: error,
		});
	}
}

function* ratingDelete(request: any) {
	try {
		const result = yield call(
			RatingService.ratingDelete,
			request.input
		);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: ratingConstants.RatingDeleteSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: ratingConstants.RatingDeleteFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: ratingConstants.RatingDeleteFailure,
			payload: error,
		});
	}
}

export const ratingSaga = {
	ratingGetSetting,
	ratingUpdateSetting,
	ratingGetDashboard,
	ratingGetAppVersions,
	ratingDelete
};